import React from 'react';
import { Button, Form, FormGroup, FormInput } from 'shards-react';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

interface EmailCodeFormProps {
  emailCode: string;
  isValid: boolean;
  isLoading: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.SyntheticEvent<HTMLFormElement>) => void;
  handleResendEmailCode: () => void;
}

const EmailCodeForm = ({ emailCode, isValid, isLoading, handleChange, handleSubmit, handleResendEmailCode }: EmailCodeFormProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <p>{t('login.mfa.message')}</p>
          <FormInput type="text" id="emailCode" placeholder={t('login.mfa.placeholder')} value={emailCode} onChange={handleChange} />
        </FormGroup>
        <Button pill theme="accent" className="d-table mx-auto" type="submit" onClick={handleSubmit} disabled={!isValid || isLoading}>
          {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />}
          {t('login.mfa.send')}
        </Button>
        <small className="form-text text-muted text-center mt-3">
          <Link to="/login" className="mx-auto" onClick={handleResendEmailCode}>
            {t('login.mfa.resend')}
          </Link>
        </small>
      </Form>
    </>
  );
};

export default EmailCodeForm;
